import { styled } from '@mui/material/styles';

import followTw from '../img/twitter_follow_grey.png';

const StyledAnchor = styled('a')({
  '& img': {
    width: 40,
    height: 40,
    marginTop: 5,
  },
  '&.active, &:hover img': {
    filter: 'brightness(120%)',
    transform: 'scale(1.1)',
    opacity: 1,
  },
});

export function FollowTwitter() {
  return (
    <StyledAnchor
      href="https://twitter.com/8bitpixapp?ref_src=twsrc%5Etfw"
      target="_blank"
      rel="noopener noreferrer"
      data-show-count="false"
    >
      <img src={followTw} alt="follow twitter" />
    </StyledAnchor>
  );
}
